import React, { useState, useEffect, useRef, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Slider from "react-slick";

import { Grid, Box, Modal } from "@mui/material";

import Bread from "../../common/Bread";
import { LangContext } from "../../context/LangContext";

import { getImageAlt } from "../../utils/imageAlt";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./details.css";

const Detail = () => {
  const { slug } = useParams();
  const lang = useContext(LangContext);
  const nep = lang.state.np;

  const sliderRef = useRef(null);
  const item = useRef({});

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Modal
  const [open, setOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  useEffect(() => {
    fetchData();
  }, [slug]);

  const fetchData = async () => {
    try {
      const res = await axios.get(
        `https://admin.icfcbank.com/api/csr/detail/${slug}`,
      );
      setData(res.data);
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Something went wrong.</div>;

  item.current = nep ? data?.detail?.np : data?.detail?.en;

  const breadcrumList = {
    image: "",
    link: "/csr",
    title: item.current?.Title,
    l1: nep ? "होम" : "Home",
    l2: nep ? "कर्पोरेट सामाजिक उत्तरदायित्व" : "CSR",
    l3: item.current?.Title,
  };

  const handleOpen = (index) => {
    setActiveIndex(index);
    setOpen(true);
    setTimeout(() => {
      sliderRef.current?.slickGoTo(index, true);
    }, 0);
  };

  const handleClose = () => setOpen(false);

  const sliderSettings = {
    dots: false, // ❌ removed dots
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
  };

  return (
    <Bread data={breadcrumList}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className="detail_content">
            <div className="detail_content-child">
              {/* COVER IMAGE (ONLY FOR csr_type_id === 5) */}
              {item.current?.csr_type_id === "5" && item.current?.DocPath && (
                <div className="coverImage">
                  <img src={item.current.DocPath} alt={getImageAlt(item.current, item.current.Title)} />
                </div>
              )}

              {/* DESCRIPTION (ALWAYS) */}
              {item.current?.Description && (
                <div
                  className="services-ck-content marginTop"
                  dangerouslySetInnerHTML={{
                    __html: item.current.Description,
                  }}
                />
              )}

              {/* IMAGE GALLERY */}
              <div
                className={`imageBox ${
                  item.current?.images?.length === 1 ? "singleImageCenter" : ""
                }`}
              >
                {item.current?.images?.map((image, index) => (
                  <div
                    className="img"
                    key={index}
                    onClick={() => handleOpen(index)}
                  >
                    <img src={image.image} alt={getImageAlt(image, image.title)} />
                    <h2>{image.title}</h2>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* MODAL GALLERY */}
      <Modal open={open} onClose={handleClose}>
        <Box className="ModelImageBox">
          <Slider ref={sliderRef} {...sliderSettings}>
            {item.current?.images?.map((image, index) => (
              <div className="sliderImage" key={index}>
                  <img src={image.image} alt={getImageAlt(image, image.title || `Slide ${index + 1}`)} />
                <p className="sliderTitle">{image.title}</p>
              </div>
            ))}
          </Slider>
        </Box>
      </Modal>
    </Bread>
  );
};

export default Detail;
